<template>
  <div>
    <Share :data="shareData"></Share>
    <common-image :data="CommonImage0"></common-image>
    <common-image :data="CommonImage1"></common-image>
    <common-image :data="CommonImage2"></common-image>
  </div>
</template>

<script>
import Share from '../../components/share.vue'
import CommonImage from '@sd-luban/common-image'

export default {
  data() {
    return {
      shareData: {"title":"一起传递爱心","bgColor":"#fff","bgImage":"","shareTitle":"和水滴筹一起，见证爱的奇迹","shareDesc":"一起公益，一起爱","shareImg":"https://luban-1254024480.cos.ap-beijing.myqcloud.com/project/imgs/1558520110557.png","shareLink":""},
      CommonImage0: {"src":"https://luban-1254024480.cos.ap-beijing.myqcloud.com/project/imgs/1558517535241.png","style":{"width":"100%"},"href":""},
      CommonImage1: {"src":"https://luban-1254024480.cos.ap-beijing.myqcloud.com/project/imgs/1558520038611.jpg","style":{"width":"100%"},"href":"https://www.shuidichou.com/gongyi/case/PF280412133433282560?channel=wx_3_tuiwen_tail112"},
      CommonImage2: {"src":"https://luban-1254024480.cos.ap-beijing.myqcloud.com/project/imgs/1558520047178.png","style":{"width":"100%"},"href":"https://www.shuidichou.com/gongyi/case/PF304574561440006144?channel=wx_3_tuiwen_tail112"},
    }
  },
  components: {
    Share,
    CommonImage,
  }
}
</script>

